import {
    Route,
    Routes,
} from 'react-router-dom';

import {ChangePage} from "./pages/ChangePage.tsx";
import {RequireAuth} from "../../../utils/RequireAuth.tsx";

// FNP-1708: forgotten-password reset moved to the login app with sign-in.
// Changing the password of a signed-in user stays here, under the user menu.
export const ResetPasswordLayout = () => {

    return (
        <Routes>
            <Route
                path='change'
                element={<RequireAuth><ChangePage/></RequireAuth>}
            />
        </Routes>
    );
};
